<template>
  <nav id='mainNav' class='pb-3'>
    <ul class='nav nav-tabs'>
      <li class='nav-item'>
        <!-- use router-link component for navigation. -->
        <!-- specify the link by passing the `to` prop. -->
        <!-- `<router-link>` will be rendered as an `<a>` tag by default -->
        <!-- the link automatically gets an active CSS class when the target route is active -->
        <router-link to='/' class='nav-link'>
          Home
        </router-link>
      </li>
      <li class='nav-item'>
        <router-link to='/content' class='nav-link' title='Geospatial Intelligence Content Extraction Specification'>
          GCES
        </router-link>
      </li>
      <li class='nav-item'>
        <router-link to='/dps' class='nav-link' title='Data Product Specification'>
          DPS
        </router-link>
      </li>
      <li class='nav-item'>
        <router-link to='/downloads' class='nav-link' title='Data Product Specification'>
          Downloads
        </router-link>
      </li>
      <li class='nav-item'>
        <router-link to='/contactus' class='nav-link' title='Data Product Specification'>
          Contact Us
        </router-link>
      </li>
      <!-- <template v-if='gx'>
      <li class='nav-item'>
        <router-link to='/protected-resource' class='nav-link' title='Protected Resource'>Protected Page</router-link>
      </li>
      <li v-if='token' class='nav-item ml-auto' style='margin-right: 9.3rem;'>
        <span id='signInText' tabindex='-1'><font-awesome-icon icon='info-circle' class='info' size='sm'></font-awesome-icon> You are signed in to GeoAxis</span>
      </li>
      <li v-if='(token == null)' class='nav-item ml-auto' style='margin-right: 13.3rem;'>
            <button id='signInBtn' type='button' href='#' class='btn btn-info ml-2' @click='login'> GeoAxis Sign In</button>
      </li>
      <li v-if='(token != null)' class='nav-item ml-auto' style='margin-right: 13.3rem;'>
            <button id='signInBtn' type='button' href='#' class='btn btn-info ml-2' @click='logout'> GeoAxis Sign Out</button>
      </li>
    </template> -->
    </ul>
  </nav>
</template>

<script>
// import AuthService from "@/AuthService";
import Config from "@/config.json";
export default {
  /* name optional but recommended for debugging */
  name: "MainNav",
  data() {
    return {
      token: JSON.parse(localStorage.getItem("tokens-gx")),
      gx: Config.geoAxis,
    };
  },
  // computed: {
  //   // a computed getter
  //   wipeToken: function () {
  //     if (gx == false) {
  //       return AuthService.authLogOut();
  //     }
  //   }
  // },
  // methods: {
  //   login() {
  //     AuthService.authLogin();
  //   },
  //   logout() {
  //     AuthService.authLogOut();
  //   }
  // }
};
</script>

<style lang="scss" scoped>
a.nav-link {
  font-size: 1.25rem;
  color: #154e7d;
}
a.nav-link.router-link-exact-active.active {
  font-weight: 500;
}
#signInText {
  font-size: 0.9rem;
  position: relative;
  top: 14px;
  padding-left: 6px;
  opacity: 0.8;
}
// #signInBtn {
//   position: relative;
//   margin-left: 0.5rem;
//   top: 4px;
// }
.info {
  opacity: 0.8;
}
</style>
